import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Icon, IconContainer } from "../visuals/styledComponents";
import { AIBadge, CompassAIBadge } from "../visuals/AIBadge";
import { CompassParagraph } from "./styledComponents";
import { greyText, darkGreen } from "../../styles";
import { useToast } from "../../store/ToastProvider";
import { SideMenuTitle } from "../../utils/configSideMenu";

const SideMenuContainer = styled.div<{ show: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ show }): string => (show ? "flex-start" : "center")};
  padding: 5px;
  border-radius: 10px;
  margin-left: ${({ show }): string => (show ? "12px" : "-2px")};
  width: ${({ show }): string => (show ? "90%" : "auto")};
  cursor: pointer;
  &:hover {
    background-color: #f8f9fa;
  }
`;

export const SideMenuItem = ({
  title,
  icon,
  iconDark,
  showText,
  navigation,
  isActive,
  iconSize = 35,
}: SideMenuItemProps): JSX.Element => {
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [activeIcon, setActiveIcon] = useState(icon);

  const handleItemClick = (path: string, isActive: boolean): void => {
    isActive ? navigate(path) : addToast("Not available", "info");
  };

  if (title === SideMenuTitle.COMPASS_AI) {
    return (
      <SideMenuContainer
        show={showText}
        onMouseDown={(): void => handleItemClick(navigation, isActive)}
      >
        {showText ? (
          <CompassAIBadge
            iconSize={35}
            fontSize={15}
            gap={10}
            fontWeight={500}
          />
        ) : (
          <AIBadge size={44} />
        )}
      </SideMenuContainer>
    );
  }

  return (
    <SideMenuContainer
      onMouseEnter={(): void => setActiveIcon(iconDark || icon)}
      onMouseLeave={(): void => setActiveIcon(icon)}
      show={showText}
      onMouseDown={(): void => handleItemClick(navigation, isActive)}
    >
      <IconContainer size={iconSize} br={1} cursor="pointer">
        <Icon src={activeIcon} />
      </IconContainer>
      <CompassParagraph
        color={activeIcon === icon ? greyText : darkGreen}
        fontSize={15}
        display={showText ? "block" : "none"}
        cursor="pointer"
        style={{
          overflow: "hidden",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </CompassParagraph>
    </SideMenuContainer>
  );
};

export type SideMenuItemProps = {
  title: SideMenuTitle;
  icon: string;
  iconDark?: string;
  showText: boolean;
  navigation: string;
  isActive: boolean;
  iconSize?: number;
};
